import React from 'react';
import { C } from '../styles';

interface Props {
  isEarning: boolean;
  selectedItem: any;
  rateOverride: string;
  setRateOverride: (v: string) => void;
}

function formatRate(item: any, isEarning: boolean): string {
  const rate = isEarning ? item.default_rate : item.default_amount;
  const unit = item.unit_label || '';
  if (rate == null || rate === '') return 'Not set' + (unit ? ' ' + unit : '');
  const num = Number(rate);
  const formatted = num.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return formatted + (unit ? ' ' + unit : '');
}

export default function RateOverrideInput({ isEarning, selectedItem, rateOverride, setRateOverride }: Props) {
  const prefix = selectedItem.calc_method === 'percent_gross' ? '%' : '$';
  const defaultRateDisplay = formatRate(selectedItem, isEarning);
  const hasDefault = defaultRateDisplay.indexOf('Not set') === -1;

  return (
    <div style={{ marginTop: 22 }}>
      <label style={{ fontSize: 12, fontWeight: 700, color: '#12262B', marginBottom: 6, display: 'block' }}>
        {isEarning ? 'Rate for this employee' : 'Amount for this employee'}
      </label>
      <div style={{ fontSize: 11.5, color: (C as any).muted, marginBottom: 8, lineHeight: 1.5 }}>
        {hasDefault
          ? 'Leave blank to use the catalog default (' + defaultRateDisplay + '). Override to set a specific value.'
          : 'No default set in catalog. Enter the amount to apply.'}
      </div>
      <div style={{ position: 'relative' }}>
        <span style={{
          position: 'absolute', left: 14, top: '50%',
          transform: 'translateY(-50%)',
          color: (C as any).muted,
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 14, pointerEvents: 'none',
        }}>
          {prefix}
        </span>
        <input
          type="text"
          value={rateOverride}
          onChange={(e) => setRateOverride(e.target.value)}
          placeholder={
            selectedItem.default_rate != null
              ? String(selectedItem.default_rate)
              : (selectedItem.default_amount != null ? String(selectedItem.default_amount) : '0.00')
          }
          style={{
            width: '100%', padding: '11px 14px 11px 28px',
            border: '1px solid ' + C.line, borderRadius: 8,
            fontFamily: "'JetBrains Mono', monospace",
            fontVariantNumeric: 'tabular-nums',
            fontSize: 14, color: C.ink, background: '#fff',
            boxSizing: 'border-box',
          }}
        />
      </div>
      <div style={{ fontSize: 11.5, color: (C as any).faint, marginTop: 5 }}>
        Applied at every pay run for this employee
      </div>
    </div>
  );
}